export const layoutScrollSelect = (state) => state.layout.scrollRefBottom;
export const userDetailSelect = (state) => state.layout.user;
export const toastDataSelect = (state) => state.layout.toastData;
export const isToastVisibleSelect = (state) => state.layout.isToastVisible;

export const themeState = (state) => state.layout.theme;
export const userEmailSelect = (state) =>
  decodeURIComponent(state.layout.userEmail);
export const hasBannerSelect = (state) => state.layout.hasBanner;
export const scrollTopValueSelect = (state) => state.layout.scrollTopValue;
export const collapsedSidebarSelect = (state) => state.layout.collapsedSidebar;
export const showUpgradePremiumModalSelect = (state) =>
  state.layout.showUpgradePremiumModal;

export const stockDataSelect = (state) => state.layout.stockData;

export const isLoadingStockSelect = (state) => state.layout.isLoadingStock;

export const showPremiumPlanModalSelect = (state) =>
  state.layout.showPremiumPlanModal;

export const showPurchasePlanModalSelect = (state) =>
  state.layout.showPurchasePlanModal;

export const lockModalSelect = (state) => state.layout.lockModal;

export const showUnsupportedBankModalSelect = (state) =>
  state.layout.showUnsupportedBankModal;

export const showWelcomeModalSelect = (state) =>
  state.layout.inAppOnboardingGuide.showWelcomeModal;

export const showGetStartedPanelSelect = (state) =>
  state.layout.inAppOnboardingGuide.showGetStartedPanel;

export const showGetStartedToggleButtonSelect = (state) =>
  state.layout.inAppOnboardingGuide.showToggleButton;

export const showFeatureDetailsKeySelect = (state) =>
  state.layout.inAppOnboardingGuide.showFeatureDetailsKey;

export const showStartGuideModalSelect = (state) =>
  state.layout.inAppOnboardingGuide.showStartGuideModal;

export const marketplaceStrategyIdSelect = (state) =>
  state.layout.inAppOnboardingGuide.marketplaceStrategyId;

export const walkthroughSelect = (state) =>
  state.layout.inAppOnboardingGuide.walkthrough;

export const welcomeWalkthroughSelect = (state) =>
  state.layout.inAppOnboardingGuide.welcomeWalkthrough;

export const walkthroughStateSelect = (state) => state.layout.userFlags;

export const showSuggestedStrategyModalSelect = (state) =>
  state.layout.showSuggestedStrategyModal;

export const showCompletionModalSelect = (state) =>
  state.layout.inAppOnboardingGuide.showCompletionModal;

export const showCreateStrategyModalSelect = (state) =>
  state.layout.showCreateStrategyModal;

export const breadcrumbDetailNameSelect = (state) =>
  state.layout.breadcrumbDetailName;
